import React from "react";
import { createRoot } from "react-dom/client";
import SurveyComponent from "../src/Component/SurveyComponent";
import './fonts/Klapt/Klapt-Bold.otf';
import './fonts/Klapt/Klapt-Regular.otf';



const root = createRoot(document.getElementById("surveyElement"));
root.render(<SurveyComponent />);